/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { GetContractByNumberV2200ResponseFromJSON, GetContractFileV1200ResponseFromJSON, GetCustomerContractsV1200ResponseFromJSON, GetCustomerMeteringPointsV2200ResponseFromJSON, } from '../models/index';
/**
 *
 */
export class ContractApi extends runtime.BaseAPI {
    /**
     * Upload contract
     * Upload contract
     */
    async fileUploadV1Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling fileUploadV1().');
        }
        if (requestParameters['uploadFile'] == null) {
            throw new runtime.RequiredError('uploadFile', 'Required parameter "uploadFile" was null or undefined when calling fileUploadV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['uploadFile'] != null) {
            formParams.append('upload_file', requestParameters['uploadFile']);
        }
        const response = await this.request({
            path: `/v1/contracts/{contract_number}/file`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Upload contract
     * Upload contract
     */
    async fileUploadV1(requestParameters, initOverrides) {
        await this.fileUploadV1Raw(requestParameters, initOverrides);
    }
    /**
     * List of all contracts
     */
    async getAllContractsV2Raw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['orderBy'] != null) {
            queryParameters['order_by'] = requestParameters['orderBy'];
        }
        if (requestParameters['customerIdIn'] != null) {
            queryParameters['customer_id__in'] = requestParameters['customerIdIn'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v2/contracts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerContractsV1200ResponseFromJSON(jsonValue));
    }
    /**
     * List of all contracts
     */
    async getAllContractsV2(requestParameters = {}, initOverrides) {
        const response = await this.getAllContractsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Contract by contract number
     * Contract by contract number
     */
    async getContractByNumberV2Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling getContractByNumberV2().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v2/contracts/{contract_number}`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractByNumberV2200ResponseFromJSON(jsonValue));
    }
    /**
     * Contract by contract number
     * Contract by contract number
     */
    async getContractByNumberV2(requestParameters, initOverrides) {
        const response = await this.getContractByNumberV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Contract file by contract number
     */
    async getContractFileV1Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling getContractFileV1().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v1/contract/{contract_number}/file`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractFileV1200ResponseFromJSON(jsonValue));
    }
    /**
     * Contract file by contract number
     */
    async getContractFileV1(requestParameters, initOverrides) {
        const response = await this.getContractFileV1Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * All metering points for contract
     * All metering points for contract
     */
    async getMeteringPointContractV2Raw(requestParameters, initOverrides) {
        if (requestParameters['contractNumber'] == null) {
            throw new runtime.RequiredError('contractNumber', 'Required parameter "contractNumber" was null or undefined when calling getMeteringPointContractV2().');
        }
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("firebase", []);
        }
        const response = await this.request({
            path: `/v2/contracts/{contract_number}/metering-points`.replace(`{${"contract_number"}}`, encodeURIComponent(String(requestParameters['contractNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerMeteringPointsV2200ResponseFromJSON(jsonValue));
    }
    /**
     * All metering points for contract
     * All metering points for contract
     */
    async getMeteringPointContractV2(requestParameters, initOverrides) {
        const response = await this.getMeteringPointContractV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
}
